import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEditorParagraph = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 448 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M424 32H195.8c-86.76 0-160.7 67.48-163.7 154.2C28.88 277.2 101.7 352 192 352h48v104c0 13.25 10.75 24 24 24S288 469.3 288 456V80h48v376c0 13.25 10.75 24 24 24S384 469.3 384 456V80h40C437.3 80 448 69.25 448 56C448 42.74 437.3 32 424 32zM240 304H192C130.1 304 80 253.9 80 192S130.1 80 192 80h48V304z",
		fill: "currentColor"
	})
});
export default SvgEditorParagraph;
